export enum StatusEnum {
	ACTIVE = 0,
	INACTIVE = 1,
	PENDING = 2,
  }
